import React from "react";
import Switch from "react-ios-switch/lib/Switch";

import { systemGreenColor } from "../../../views/shared-screens/constants";

export const ToggleSwitch = (props) => {
  const { index, isActive } = props;

  // Let the parent update the selected item.
  const handleChange = () => {
    props.onChange(props.id);
  };

  return (
    <Switch
      key={index}
      checked={isActive}
      handleColor="white"
      offColor="gray"
      onChange={handleChange}
      onColor={systemGreenColor}
      className="switch"
      disabled={props.disabled}
    />
  );
};
